import axios from 'axios'
import endpoints from '../configs/endpoints'

class LoanService {
    /** save loans calculation to backend */
    saveForm(request, callback) {
        const { token, ...dataToSend } = request
        const url = window._env_.isWebpack ? '/loans/v1/calcs' : endpoints.baseTTSServiceUrl + endpoints.saveLoanUrl
        const userHeaders = {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
            Accept: 'application/json'
        }
        const options = {
            headers: userHeaders
        }

        axios.post(url, dataToSend, options).then(
            response => {
                if (response.status === 200) {
                    callback({ status: 'success', data: response.data })
                } else {
                    callback({ status: 'fail', error: response.status })
                }
            },
            error => {
                callback({ status: 'fail', error })
            }
        )
    }

    /** perform loans calculation */
    calcForm(request, callback) {
        const { token, ...dataToSend } = request
        const url = window._env_.isWebpack ? '/loans/v1/calc' : endpoints.baseTTSServiceUrl + endpoints.calcLoanUrl
        const userHeaders = {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
            Accept: 'application/json'
        }
        const options = {
            headers: userHeaders
        }

        axios.post(url, dataToSend, options).then(
            response => {
                if (response.status === 200) {
                    const { calculationResult } = response.data
                    callback({ status: 'success', data: calculationResult })
                } else {
                    callback({ status: 'fail', error: response.status })
                }
            },
            error => {
                callback({ status: 'fail', error })
            }
        )
    }
}

export default new LoanService()
